import React, { useEffect, useRef, useState } from "react";
import "wicg-inert";

import Button from "layout/atoms/Button";
import Icon from "layout/atoms/Icon";
import Portal from "layout/atoms/Portal";

import { ReactComponent as CloseSvg } from "assets/icons/close.svg";
import { Backdrop, CloseButton, Content } from "./styles";

const Modal = (props) => {
  const [active, setActive] = useState(false);
  const { open, onClose, locked } = props;
  const backdrop = useRef(null);

  useEffect(() => {
    const { current } = backdrop;
    const transitionEnd = () => setActive(open);
    const keyHandler = (e) =>
      !locked && [27].indexOf(e.which) >= 0 && onClose();
    const clickHandler = (e) => !locked && e.target === current && onClose();

    if (current) {
      current.addEventListener("transitionend", transitionEnd);
      current.addEventListener("click", clickHandler);
      window.addEventListener("keyup", keyHandler);
    }

    let timeoutId;
    if (open) {
      timeoutId = window.setTimeout(() => {
        document.activeElement.blur();
        setActive(open);
        document.querySelector("#root").setAttribute("inert", "true");
      }, 10);
    }

    return () => {
      if (current) {
        current.removeEventListener("transitionend", transitionEnd);
        current.removeEventListener("click", clickHandler);
      }

      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }

      document.querySelector("#root").removeAttribute("inert");
      window.removeEventListener("keyup", keyHandler);
    };
  }, [open, locked, onClose]);

  return (
    <>
      {(open || active) && (
        <Portal className="modal-portal">
          <Backdrop ref={backdrop} className={active && open && "active"}>
            <Content className="modal-content">
              {props.children}
              <CloseButton>
                <Button size="sm-square" color="white" onClick={onClose}>
                  <Icon src={CloseSvg} />
                </Button>
              </CloseButton>
            </Content>
          </Backdrop>
        </Portal>
      )}
    </>
  );
};

export default Modal;
